import React from 'react';
import { LazySection } from './LazySection';
export function Urgencia() {
  return <LazySection className="bg-gradient-to-br from-rust to-[#7a3820] text-cream text-center !py-[70px] md:!py-[90px]" data-id="element-395">
      <div className="container-custom" data-id="element-396">
        <h2 className="text-cream text-[clamp(30px,4.5vw,46px)] max-w-[820px] mx-auto mb-6 leading-[1.2]" data-id="element-397">
          Cada año que pasa sin entender el{' '}
          <span className="highlight-keyword-light" data-id="element-398">origen</span> es otro año
          repitiendo lo mismo.
        </h2>
        <p className="text-[17px] text-cream/90 max-w-[640px] mx-auto mb-3.5" data-id="element-399">
          No hace falta inventar una urgencia. La urgencia ya la conocés: es el
          tiempo que ya pasó.
        </p>
        <p className="text-[17px] text-cream/90 max-w-[640px] mx-auto" data-id="element-400">
          No necesitás más información. Necesitás ver el{' '}
          <span className="highlight-keyword-light" data-id="element-401">origen</span>.
        </p>
      </div>
    </LazySection>;
}